import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#0079BF";

function IconPaper({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M11.69 8.545c1.29.842 2.584 1.68 3.877 2.52.127.083.126.085-.004.17-2.421 1.575-4.843 3.149-7.262 4.728-.111.073-.178.025-.26-.03l-2.995-1.95-4.213-2.738c-.044-.029-.095-.05-.132-.105l1.103-.719 2.883-1.875.827.541 1.825 1.18c.248.16.498.317.741.483.084.058.142.054.225-.001.853-.558 1.71-1.111 2.564-1.666l.11-.077.71-.461zM8.31.042c2.413 1.574 4.828 3.143 7.243 4.713.04.027.08.056.123.084-.027.058-.081.074-.123.102l-.696.453-3.878 2.522c-.037.024-.073.05-.11.076-.855.555-1.71 1.108-2.564 1.666-.083.055-.141.06-.225.002-.243-.167-.493-.324-.741-.485L5.514 7.996c-.656-.428-1.31-.858-1.967-1.286-.674-.44-1.348-.878-2.023-1.316l-.715-.465c-.037-.024-.073-.05-.12-.082.151-.1.293-.192.436-.284C3.438 3.058 5.75 1.555 8.064.048c.087-.057.15-.069.246-.006z"/>
        </svg>
    );
}

export default IconPaper;
